import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";

const phoneUtil = PhoneNumberUtil.getInstance();

let createCustomerValidationForm = yup.object().shape({
  full_name: yup.string().required("Name is required"),
  email: yup.string().email().nullable(),
  primary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  secondary_contact: yup
    .string()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "" || /^\+\d{1,4}$/.test(value.trim())) {
        return true;
      }
      try {
        const parsed = phoneUtil.parseAndKeepRawInput(value, "NP");
        return phoneUtil.isValidNumber(parsed);
      } catch (err) {
        return false;
      }
    }),
  address: yup.string().required("Address is required"),
  vat_pan: yup
    .string()
    .test("typeError", "Invalid VAT/PAN number", function (value) {
      return !isNaN(Number(value));
    })
    .nullable(),
});

export { createCustomerValidationForm };

/* Types */
export interface ICreateCustomer
  extends yup.InferType<typeof createCustomerValidationForm> {}
